var a={API_VERSION:2,API_VERSION_MINOR:0,GATEWAY:"adyen",URL:"https://pay.google.com/gp/p/js/pay.js"};export{a as default};
//# sourceMappingURL=config.js.map
